export default {"src":"/_next/static/media/33.c14464c7.svg","height":35,"width":140,"blurWidth":0,"blurHeight":0};